import { Pencil, CheckCircle2 } from 'lucide-react';
import { useProfile } from '../../../../../context/profile/ProfileContext';

const SubscriptionPaymentMethodCard = () => {
  const {
    effectiveSub,
    subscription,
    isTrialUser,
    setShowPmModal,
    formatDate
  } = useProfile();

  if (isTrialUser) return null;

  const rawMethod = (effectiveSub?.payment_method || effectiveSub?.paymentMethod || subscription?.payment_method || subscription?.paymentMethod || '').toLowerCase();
  const tokenId = effectiveSub?.razorpay_token_id || subscription?.razorpay_token_id || '';
  const hasRecurringMandate = Boolean(effectiveSub?.razorpay_subscription_id || (tokenId && tokenId !== 'UPI' && !/^\d{4}$/.test(tokenId)));
  const isCard = ['card', 'credit_card', 'debit_card'].includes(rawMethod) || /^\d{4}$/.test(tokenId);
  const cardLast4 = tokenId && tokenId.length >= 4 ? tokenId.slice(-4) : '1111';

  return (
    <section className="bg-white rounded-2xl sm:rounded-3xl border border-gray-100 p-4 sm:p-6 lg:p-7 shadow-sm">
      <div className="flex justify-between items-center border-b border-slate-100 pb-3.5 sm:pb-4 mb-3.5 sm:mb-4 gap-2">
        <div>
          <h2 className="font-semibold text-slate-900 text-sm sm:text-base">Payment method</h2>
          <div className="text-xs text-slate-500 mt-0.5 font-normal">
            {hasRecurringMandate ? 'Auto-debited each cycle via Razorpay.' : 'One-time payment completed (No recurring auto-debit).'}
          </div>
        </div>
        {hasRecurringMandate && (
          <button
            onClick={() => setShowPmModal(true)}
            className="px-3 sm:px-3.5 py-1.5 bg-slate-50 hover:bg-slate-100 text-slate-700 rounded-xl font-semibold text-xs border border-slate-200 hover:border-slate-300 transition-all flex items-center gap-1.5 shadow-2xs active:scale-95 cursor-pointer whitespace-nowrap"
          >
            <Pencil size={12} className="text-slate-500" />
            <span>Update</span>
          </button>
        )}
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div className="flex items-center gap-3.5">
          <div className="w-12 h-8 bg-white border border-slate-200 rounded-lg font-extrabold text-[10px] text-slate-700 flex items-center justify-center shrink-0 uppercase tracking-wide">
            {isCard ? 'VISA' : (rawMethod ? rawMethod.toUpperCase() : 'UPI')}
          </div>
          <div>
            <div className="font-mono text-sm font-semibold tracking-wide text-slate-800">
              {hasRecurringMandate
                ? (isCard
                    ? `•••• •••• •••• ${cardLast4}`
                    : (tokenId && tokenId !== 'UPI' && !/^\d{4}$/.test(tokenId) ? tokenId : 'UPI Autopay Mandate'))
                : `One-Time Payment (${rawMethod ? rawMethod.toUpperCase() : 'UPI'})`}
            </div>
            <div className="text-xs text-slate-500 mt-0.5">
              {hasRecurringMandate
                ? (isCard ? 'Card Mandate Active · Autopay Enabled' : 'UPI Mandate Active · Autopay Enabled')
                : 'One-time payment completed · Autopay not enabled'}
            </div>
          </div>
        </div>
        <span className="inline-flex items-center gap-1.5 text-xs font-normal text-emerald-600">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
          {hasRecurringMandate ? 'Mandate active' : 'Paid in full'}
        </span>
      </div>

      <div className="text-xs text-slate-500 leading-normal mt-4 pt-3.5 border-t border-slate-100 flex gap-2 items-start">
        <CheckCircle2 size={15} className="text-[#0ea5a0] shrink-0 mt-0.5" />
        {hasRecurringMandate ? (
          <span>Next auto-debit on <b>{formatDate(
            (effectiveSub.next_billing_at && (!effectiveSub.start_date || new Date(effectiveSub.next_billing_at) > new Date(effectiveSub.start_date)))
              ? effectiveSub.next_billing_at
              : (effectiveSub.end_date || effectiveSub.next_billing_at || effectiveSub.nextBillingAt || effectiveSub.trial_end)
          )}</b>. As required by RBI, we'll notify you 24 hours before each charge.</span>
        ) : (
          <span>Subscription active through <b>{formatDate(effectiveSub.end_date || effectiveSub.next_billing_at)}</b>. No recurring auto-debit is scheduled.</span>
        )}
      </div>
    </section>
  );
};

export default SubscriptionPaymentMethodCard;
